(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vueCloudCarousel", [], factory);
	else if(typeof exports === 'object')
		exports["vueCloudCarousel"] = factory();
	else
		root["vueCloudCarousel"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(12)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel_item_cloud_carousel_item__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_emitter__ = __webpack_require__(6);
//
//
//
//
//
//




var cancelFrame = window.cancelAnimationFrame || window.cancelRequestAnimationFrame;
var requestFrame = window.requestAnimationFrame;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CloudCarousel',
    componentName: 'CloudCarousel',
    components: { CloudCarouselItem: __WEBPACK_IMPORTED_MODULE_0__carousel_item_cloud_carousel_item__["a" /* default */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__util_emitter__["a" /* default */]],
    data: function data() {
        return {
            carouselOptions: {},
            defaultOptions: {
                xOrigin: null, // null: calculated automatically
                yOrigin: null,
                xRadius: null,
                yRadius: null,
                farScale: 0.5, // scale of the farthest item
                transforms: true, // enable CSS transforms
                smooth: true, // enable smooth animation via requestAnimationFrame()
                fps: 30, // fixed frames per second (if smooth animation is off)
                speed: 4, // positive number
                autoPlay: 0, // [ 0: off | number of items (integer recommended, positive is clockwise) ]
                autoPlayDelay: 4000,
                bringToFront: false,
                itemClass: 'carousel-item',
                frontItemClass: 'current-item',
                handle: 'carousel',
                farOpacity: 0.5
            },

            autoPlayTimer: 0,
            rotation: Math.PI / 2, // start with the first item positioned in front
            destRotation: Math.PI / 2,
            timer: 0,
            itemOptions: {
                transforms: true
            },
            items: [],
            initTimer: null,
            currentItem: null
        };
    },

    props: {
        options: {
            xOrigin: null, // null: calculated automatically
            yOrigin: null,
            xRadius: null,
            yRadius: null,
            farScale: 0.5, // scale of the farthest item
            transforms: true, // enable CSS transforms
            smooth: true, // enable smooth animation via requestAnimationFrame()
            fps: 30, // fixed frames per second (if smooth animation is off)
            speed: 4, // positive number
            autoPlay: 0, // [ 0: off | number of items (integer recommended, positive is clockwise) ]
            autoPlayDelay: 4000,
            bringToFront: false,
            itemClass: 'cloud9-item',
            frontItemClass: null,
            handle: 'carousel',
            farOpacity: 0.5
        }
    },
    methods: {
        renderItem: function renderItem(itemIndex, rotation) {
            var item = this.items[itemIndex];
            var sin = Math.sin(rotation);
            var farScale = this.carouselOptions.farScale;
            var farOpacity = this.carouselOptions.farOpacity;
            var scale = farScale + (1 - farScale) * (sin + 1) * 0.5;
            var opacity = farScale + (1 - farOpacity) * (sin + 1) * 0.5;

            item.moveTo(this.carouselOptions.xOrigin + scale * (Math.cos(rotation) * this.carouselOptions.xRadius - item.fullWidth * 0.5), this.carouselOptions.yOrigin + scale * sin * this.carouselOptions.yRadius, scale, opacity);

            return item;
        },
        render: function render() {
            var count = this.items.length;
            var spacing = 2 * Math.PI / count;
            var radians = this.rotation;
            var nearest = this.nearestIndex();

            for (var i = 0; i < count; i++) {
                var item = this.renderItem(i, radians);

                if (i === nearest) {
                    item.element.classList.add(this.carouselOptions.frontItemClass);
                    this.currentItem = item;
                } else {
                    item.element.classList.remove(this.carouselOptions.frontItemClass);
                }

                radians += spacing;
            }

            this.$emit('rendered', this);
        },
        playFrame: function playFrame() {
            var rem = this.destRotation - this.rotation;
            var now = this.time();
            var dt = (now - this.lastTime) * 0.002;
            this.lastTime = now;

            if (Math.abs(rem) < 0.003) {
                this.rotation = this.destRotation;
                this.pause();
                this.$emit('animationFinished', this);
            } else {
                // Asymptotically approach the destination
                this.rotation = this.destRotation - rem / (1 + this.carouselOptions.speed * dt);
                this.scheduleNextFrame();
            }

            this.render();
        },
        scheduleNextFrame: function scheduleNextFrame() {
            this.lastTime = this.time();

            this.timer = this.carouselOptions.smooth && cancelFrame ? requestFrame(this.playFrame) : setTimeout(this.playFrame, 1000 / this.carouselOptions.fps);
        },
        itemsRotated: function itemsRotated() {
            return this.items.length * (Math.PI / 2 - this.rotation) / (2 * Math.PI);
        },
        floatIndex: function floatIndex() {
            var count = this.items.length;
            var floatIndex = this.itemsRotated() % count;

            // Make sure float-index is positive
            return floatIndex < 0 ? floatIndex + count : floatIndex;
        },
        nearestIndex: function nearestIndex() {
            return Math.round(this.floatIndex()) % this.items.length;
        },
        play: function play() {
            if (this.timer === 0) this.scheduleNextFrame();
        },
        pause: function pause() {
            this.carouselOptions.smooth && cancelFrame ? cancelFrame(this.timer) : clearTimeout(this.timer);
            this.timer = 0;
        },


        //
        // Spin the carousel by (+-) count items
        //
        go: function go(count) {
            this.$emit('beforeRender', this);
            this.destRotation += 2 * Math.PI / this.items.length * count;
            this.play();
        },
        goTo: function goTo(index) {
            var count = this.items.length;

            // Find the shortest way to rotate item to front
            var diff = index - this.floatIndex() % count;

            if (2 * Math.abs(diff) > count) diff -= diff > 0 ? count : -count;

            // Halt any rotation already in progress
            this.destRotation = this.rotation;

            // Spin the opposite way to bring item to front
            this.go(-diff);

            // Return rotational distance (in items) to the target
            return diff;
        },


        // deactivate() {
        //     this.pause();
        //     clearInterval( this.autoPlayTimer );
        //     if( this.options.buttonLeft ) this.options.buttonLeft.unbind( 'click' );
        //     if( this.options.buttonRight ) this.options.buttonRight.unbind( 'click' );
        //     $container.unbind( '.cloud9' );
        // },

        autoPlay: function autoPlay() {
            var _this = this;

            this.autoPlayTimer = setInterval(function () {
                _this.go(_this.carouselOptions.autoPlayAmount);
            }, this.carouselOptions.autoPlayDelay);
        },
        enableAutoPlay: function enableAutoPlay() {
            var _this2 = this;

            // Stop auto-play on mouse over
            this.$on('handleItemMouseOver', function () {
                clearInterval(_this2.autoPlayTimer);
            });

            // Resume auto-play when mouse leaves the container
            this.$on('handleItemMouseOut', function () {
                _this2.autoPlay();
            });

            this.autoPlay();
        },
        bindControls: function bindControls() {
            var _this3 = this;

            var self = this;
            if (this.options.buttonLeft) {
                this.options.buttonLeft.bind('click', function () {
                    self.go(-1);
                    return false;
                });
            }

            if (this.options.buttonRight) {
                this.options.buttonRight.bind('click', function () {
                    self.go(1);
                    return false;
                });
            }

            if (this.options.bringToFront) {
                this.$on('handleItemClick', function (item) {
                    if (item) {
                        _this3.goTo(_this3.items.indexOf(item));
                        _this3.$emit('itemClick', item);
                    }
                });
            }
        },
        finishInit: function finishInit() {
            this.items = this.$children;

            clearInterval(this.initTimer);

            // Init items
            for (var i = 0; i < this.items.length; i++) {
                var prev = void 0,
                    next = void 0;
                if (i === 0) {
                    next = this.items[this.items.length - 1];
                } else {
                    next = this.items[i - 1];
                }
                if (i === this.items.length - 1) {
                    prev = this.items[0];
                } else {
                    prev = this.items[i + 1];
                }
                this.items[i].init(this.carouselOptions.transforms, prev, next);
            }

            // Disable click-dragging of items
            this.$refs.carousel.addEventListener('mousedown', function () {
                return false;
            });
            this.$refs.carousel.addEventListener('onselectstart', function () {
                return false;
            });

            if (this.carouselOptions.autoPlayAmount !== 0) this.enableAutoPlay();
            this.bindControls();
            this.render();
            this.$emit('loaded', this);
        },
        initRenderParams: function initRenderParams() {
            this.carouselOptions = Object.assign({}, this.defaultOptions, this.options);
            this.carouselOptions.autoPlayAmount = this.options.autoPlay;
            this.carouselOptions.xOrigin = !this.options.xOrigin ? this.$refs.carousel.clientWidth * 0.5 : this.options.xOrigin;
            this.carouselOptions.yOrigin = !this.options.yOrigin ? this.$refs.carousel.clientHeight * 0.1 : this.options.yOrigin;
            this.carouselOptions.xRadius = !this.options.xRadius ? this.$refs.carousel.clientWidth / 2.3 : this.options.xRadius;
            this.carouselOptions.yRadius = !this.options.yRadius ? this.$refs.carousel.clientHeight / 6 : this.options.yRadius;
        },
        time: function time() {
            return !window.performance || !window.performance.now ? +new Date() : performance.now();
        },
        getNextItem: function getNextItem() {
            return this.items[this.nearestIndex()].next;
        },
        getPrevItem: function getPrevItem() {
            return this.items[this.nearestIndex()].prev;
        },
        getNearestItem: function getNearestItem() {
            return this.items[this.nearestIndex()];
        },
        setOptions: function setOptions(options) {
            this.carouselOptions = Object.assign({}, this.carouselOptions, options);
            this.render();
        },
        goNext: function goNext() {
            clearInterval(this.autoPlayTimer);
            this.go(1);
            if (this.carouselOptions.autoPlayAmount !== 0) this.autoPlay();
        },
        goPrev: function goPrev() {
            clearInterval(this.autoPlayTimer);
            this.go(-1);
            if (this.carouselOptions.autoPlayAmount !== 0) this.autoPlay();
        },
        pauseAutoPlay: function pauseAutoPlay() {
            clearInterval(this.autoPlayTimer);
        },
        resumeAutoPlay: function resumeAutoPlay() {
            this.autoPlay();
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.initRenderParams();
            _this4.initTimer = setInterval(function () {
                _this4.finishInit();
            }, 50);
        });
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.autoPlayTimer);
    },
    created: function created() {}
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cloud_carousel_item_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0098ab7b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cloud_carousel_item_vue__ = __webpack_require__(15);
function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0098ab7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cloud_carousel_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0098ab7b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cloud_carousel_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_emitter__ = __webpack_require__(6);
//
//
//
//
//
//



var transform = function () {
    var vendors = ['webkit', 'moz', 'ms'];
    var style = document.createElement("div").style;
    var trans = 'transform' in style ? 'transform' : undefined;

    for (var i = 0, count = vendors.length; i < count; i++) {
        var prop = vendors[i] + 'Transform';
        if (prop in style) {
            trans = prop;
            break;
        }
    }

    return trans;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CloudCarouselItem',
    componentName: 'CloudCarouselItem',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__util_emitter__["a" /* default */]],
    data: function data() {
        return {
            element: null,
            width: 0,
            height: 0,
            fullWidth: 0,
            fullHeight: 0,
            x: 0,
            y: 0,
            scale: 1,
            transformsOpt: true,
            prev: null,
            next: null
        };
    },

    props: {
        params: {
            type: Object,
            default: null
        }
    },
    methods: {
        moveTo: function moveTo(x, y, scale, opacity) {
            this.width = this.fullWidth * scale;
            this.height = this.fullHeight * scale;
            this.x = x;
            this.y = y;
            this.scale = scale;

            var style = this.element.style;
            style.zIndex = "" + scale * 100 | 0;

            if (transform && this.transformsOpt) {
                style[transform] = "translate(" + x + "px, " + y + "px) scale(" + scale + ")";
            } else {
                style.width = this.width + "px";
                style.left = x + "px";
                style.top = y + "px";
            }
            style.opacity = opacity;
        },
        init: function init(transformsOpt, prev, next) {
            this.element = this.$refs.carouselItem;
            this.element.item = this;
            this.fullWidth = this.element.offsetWidth;
            this.fullHeight = this.element.offsetHeight;
            this.transformsOpt = transformsOpt;
            this.prev = prev;
            this.next = next;

            if (transform && transformsOpt) {
                this.element.style[transform + "Origin"] = "0 0";
            }
        },
        itemClick: function itemClick() {
            this.dispatch('CloudCarousel', 'handleItemClick', [this]);
        },
        itemMouseOver: function itemMouseOver() {
            this.dispatch('CloudCarousel', 'handleItemMouseOver');
        },
        itemMouseOut: function itemMouseOut() {
            this.dispatch('CloudCarousel', 'handleItemMouseOut');
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel_index_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__carousel_item_index_js__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CloudCarousel", function() { return __WEBPACK_IMPORTED_MODULE_0__carousel_index_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CloudCarouselItem", function() { return __WEBPACK_IMPORTED_MODULE_1__carousel_item_index_js__["a"]; });



var components = [__WEBPACK_IMPORTED_MODULE_0__carousel_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__carousel_item_index_js__["a" /* default */]];

var install = function install(Vue) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    components.forEach(function (component) {
        Vue.component(component.name, component);
    });
};



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloud_carousel__ = __webpack_require__(9);


__WEBPACK_IMPORTED_MODULE_0__cloud_carousel__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__cloud_carousel__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__cloud_carousel__["a" /* default */]);
}; //注册组件

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__cloud_carousel__["a" /* default */]);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cloud_carousel_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7750816c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cloud_carousel_vue__ = __webpack_require__(16);
function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7750816c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cloud_carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7750816c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cloud_carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(11);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("787eeeda", content, true, {});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".wrap[data-v-7750816c]{padding:0;width:100%;height:100%;position:relative;overflow:hidden}.noselect[data-v-7750816c]{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("683168b0", content, true, {});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".cloud-carousel-item[data-v-0098ab7b]{cursor:pointer;position:absolute;display:inline-block}", ""]);

// exports


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"carouselItem",staticClass:"cloud-carousel-item",on:{"click":_vm.itemClick,"mouseover":_vm.itemMouseOver,"mouseout":_vm.itemMouseOut}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"carousel",staticClass:"wrap noselect"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloud_carousel_item__ = __webpack_require__(4);


__WEBPACK_IMPORTED_MODULE_0__cloud_carousel_item__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__cloud_carousel_item__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__cloud_carousel_item__["a" /* default */]);
}; //注册组件

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__cloud_carousel_item__["a" /* default */]);

/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map